export const INDICATOR_WIDTH_PX = 21;
export const PC_VIEWER_SEEKBAR_HIDDEN_HEIGHT_PX = 4;
export const PC_VIEWER_SEEKBAR_HEIGHT_PX = 12;
